let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kkFYV")).then(() => parcelRequire('77FPb'));